import { assertFile } from '@/utils'

import axios, { withToken } from '../axios'

/**
 * Updates the brand image.
 *
 * @param tokenV2 Valid token with an AccountId.
 * @param formData Form with file to be uploaded.
 */
export async function updateBrand (tokenV2: string, formData: FormData, providerId: number) {
  assertFile(formData)

  const config = withToken(tokenV2)
  config.headers['Content-Type'] = 'multipart/form-data'

  await axios.put<void>(
    `/menu/accounts/${providerId}/images/brand`,
    formData,
    config
  )
}

export default {
  updateBrand
}
